module.exports = __webpack_public_path__ + "static/media/eye.eb8b55ea.svg";